// src/components/DesktopNav.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './DesktopNav.css';

const DesktopNav = () => {
  const location = useLocation();
  
  // Check if the current route matches the nav item
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  // Function to scroll to top when on dashboard
  const handleHomeClick = (e) => {
    // If already on dashboard, prevent default link behavior and scroll to top
    if (location.pathname === '/dashboard') {
      e.preventDefault();
      
      // Smooth scroll to top
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      
      // Fallbacks for older browsers
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  };
  
  return (
    <div className="desktop-nav">
      <Link 
        to="/dashboard" 
        className={`desktop-nav-item ${isActive('/dashboard') ? 'active' : ''}`}
        onClick={handleHomeClick}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        <span>Home</span>
      </Link>

      <Link
        to="/schedule"
        className={`desktop-nav-item ${isActive('/schedule') ? 'active' : ''}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
          <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
        </svg>
        <span>Schedule</span>
      </Link>

      <Link
        to="/events"
        className={`desktop-nav-item ${isActive('/events') ? 'active' : ''}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
        <span>Events</span>
      </Link>

      <Link
        to="/campus-map"
        className={`desktop-nav-item ${isActive('/campus-map') ? 'active' : ''}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
          <circle cx="12" cy="10" r="3"></circle>
        </svg>
        <span>Map</span>
      </Link>

      <Link
        to="/user-details"
        className={`desktop-nav-item ${isActive('/user-details') ? 'active' : ''}`}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        <span>Account</span>
      </Link>
    </div>
  );
};

export default DesktopNav;